export function withProjectPrefix(path: string, projectId?: string): string {
  return projectId ? `/project/${projectId}${path}` : path;
}

export function replaceRouteParams(
  path: string,
  params: Record<string, string | undefined>
): string {
  let replacedPath = path;

  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      replacedPath = replacedPath.replace(`:${key}`, value);
    }
  });

  return replacedPath;
}
